import ContentList from '@/components/blocks/content_list/ContentList';

export default async function ContentListContent({ block, position }) {
  const data = block.content_list.reference[0];

  if (data === null || !data?.modular_blocks) {
    return null;
  }

  const { modular_blocks, background_color_picker, cta, title } = data;

  return modular_blocks.map((block, index) => {
    switch (Object.keys(block)[0]) {
      case 'classic':
        return (
          <ContentList
            key={index}
            block={block}
            position={position}
            title={title}
            background_color={background_color_picker}
            cta={cta}
            cta_url={cta?.reference?.[0]?.url}
          />
        );
      default:
        return <div key={index} className="empty-component"></div>;
    }
  });
}
